import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import * as conf from "../config/common"


export default function FileUploader({ setInvalidMsg, DocTypes, files, setFiles, file_ext }) {

  let app = ApplicantContainer.useContainer();    
  
  files = app.documents.[DocTypes];

  let [draggedIn, setDraggedIn] = useState(false);
  

  function chkFileTypeAndSize(existFile, file) {

    let filterFiles = [];
    let ctr = 0;

    //alert(existFile.length);
    for(let f of existFile) {
      
      ++ctr;
    }
  
    // if(ctr >= conf.MAX_FILES_PER_SUPPORT_DOC) return filterFiles;

    // for(let f of file) {
      
    //   if (f.size <= conf.MAX_ALLOWED_FILE_SIZE && conf.ALLOWED_FILE_TYPES.search(f.type) > 0) {
        
    //     if(++ctr > conf.MAX_FILES_PER_SUPPORT_DOC) return filterFiles;
    //     filterFiles.push(f);        
    //   }
    // }
    // return filterFiles;



    if(ctr >= conf.MAX_FILES_PER_SUPPORT_DOC) return filterFiles;

    for(let f of file) {
      
      if (f.size > 0 && f.size <= conf.MAX_ALLOWED_FILE_SIZE && conf.ALLOWED_FILE_TYPES.search(f.type) > 0) {
        
        if(++ctr > conf.MAX_FILES_PER_SUPPORT_DOC) return filterFiles;
        filterFiles.push(f);        
      }
    }
    return filterFiles;


  }


  let inputFile = useRef(null);

 
function removeSameFile(existFile, file)
{

}

  function removeFile(ev, index) {
    
    ev.stopPropagation();
    let _files = files.filter((f, ind) => ind !== index);
    setFiles(_files);

    app.onChangeDocuments({...app.documents, [DocTypes] :_files})

  }

  function onDragEnter(ev) {
    ev.preventDefault();
    setDraggedIn(true);
  }
  function onDragLeave(ev) {
    ev.preventDefault();
    setDraggedIn(false);
  }
  function onDrop(ev) {

    let filterFiles = chkFileTypeAndSize(files, ev.dataTransfer.files);

    ev.preventDefault();
   
    let _files = [...files, ...filterFiles];
    setFiles(_files);
    setDraggedIn(false);

 
    app.onChangeDocuments({...app.documents, [DocTypes] :_files})



    setInvalidMsg(DocTypes);

  }
  function onDragOver(ev) {
    ev.preventDefault();
  }
  function openFileDialog() {
    inputFile.current.click();    
  }
  
  function resetFile(ev){
    document.getElementById(DocTypes).value = null;

  }

  function fileInputAdd(ev) {

    let filterFiles = chkFileTypeAndSize(files, ev.target.files);
    let _files = [...files, ...filterFiles];
 
    setFiles(_files);
   


    app.onChangeDocuments({...app.documents, [DocTypes] :_files})

    setInvalidMsg(DocTypes);
    
  }
  
 

return (  
<div  className={      
      `file-uploader-drop-box`}>   

      <div
        className={
          files.length > 0
            ? `file-uploader-no-flex  ${draggedIn ? "dragged-over" : ""}`
            : `file-uploader-flex  ${draggedIn ? "dragged-over" : ""}`
        }
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onClick={openFileDialog}
      >
        {files.length > 0 ? (
          <>
            {files.map((f, index) => {
              return (
                <div className="multi-file-row" key={index}>
                  <Button
                    className="multi-file-remove-btn"                    
                    onClick={(ev) => removeFile(ev, index)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-square-fill" viewBox="0 0 16 16">
  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>
</svg>
                  </Button>
                  {f.name} ({f.size/conf.KILO_BYTES_PER_BYTE > 1024 ? (f.size/conf.MEGA_BYTES_PER_BYTE).toFixed(2) + `MB` : (f.size/conf.KILO_BYTES_PER_BYTE).toFixed(2) +`KB`})
                </div>
              );
            })}
          </>
        ) : (
          <div  className="file-uploader-icon text-center">
            
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-upload" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
</svg>
            Drag & Drop or Click to choose file(s)<br/>
            Allowed file extension : {conf.ALLOW_FILE_EXT}<br/>
            Each file should not exceed {conf.MAX_ALLOWED_FILE_SIZE/conf.MEGA_BYTES_PER_BYTE}MB.<br/>
            Maximum number of files allowed is {conf.MAX_FILES_PER_SUPPORT_DOC}.
          </div>
        )}
        <input      
            id={DocTypes}
            type="file"
            multiple
            ref={inputFile}
            className="file-uploader-file"
            accept={conf.ALLOW_FILE_EXT}
            onChange={fileInputAdd}
            onClick={resetFile} 
                         
          />  
      </div>
    </div>
  );
}